export const FAQ_LINKS = {
    faqLink: 'https://support.singular.net/hc/en-us/articles/360025454492-Audiences-FAQ',
};

export const TRACK_EVENT_PREFIX = 'incrementality_';
export const MIX_PANEL_KEYS = {
    PAGE_VISIT: 'page_visit',
    REPORT_VISIT: 'report_visit',
    WIZARD_TEST_SCHEDULED: 'wizard_test_scheduled',
    WIZARD_DRAFT_SAVE: 'wizard_draft_save',
    WIZARD_SELECT_SEGMENT_THAT_IS_ALREADY_SHARED: 'wizard_select_segment_that_is_already_shared',
    WIZARD_SELECT_SEGMENT_THAT_IS_NOT_USED: 'wizard_select_segment_that_is_not_used',
};
